import {
    CREATE_NOTIFICATION_MESSAGE,
    DELETE_NOTIFICATION_MESSAGE,
    GET_NOTIFICATION_CATEGORIES,
    GET_NOTIFICATION_HISTORY,
    GET_NOTIFICATION_MESSAGES,
    SEND_NOTIFICATION_EMAILS,
    UPDATE_NOTIFICATION_MESSAGE,
} from "../actions/notificaciones";

const INITIAL_STATE = {
    isFetching: false,
    isFetchingHistory: false,
    didInvalidate: false,
    list: [],
    history: [],
    categories: [],
    isSaving: false,
    didInvalidateSave: false,
};

const notificaciones = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case `${GET_NOTIFICATION_MESSAGES}_REJECTED`:
            return {
                ...state,
                isFetching: false,
                didInvalidate: true,
            };
        case `${GET_NOTIFICATION_MESSAGES}_PENDING`:
            return {
                ...state,
                isFetching: true,
                didInvalidate: false,
            };
        case `${GET_NOTIFICATION_MESSAGES}_FULFILLED`:
            return {
                ...state,
                isFetching: false,
                didInvalidate: false,
                list: action.payload.data || [],
            };

        case `${GET_NOTIFICATION_HISTORY}_REJECTED`:
            return {
                ...state,
                isFetchingHistory: false,
            };
        case `${GET_NOTIFICATION_HISTORY}_PENDING`:
            return {
                ...state,
                isFetchingHistory: true,
            };
        case `${GET_NOTIFICATION_HISTORY}_FULFILLED`:
            return {
                ...state,
                isFetchingHistory: false,
                history: action.payload.data || [],
            };

        case `${GET_NOTIFICATION_CATEGORIES}_FULFILLED`:
            return {
                ...state,
                categories: action.payload.data || [],
            };

        case `${CREATE_NOTIFICATION_MESSAGE}_REJECTED`:
        case `${UPDATE_NOTIFICATION_MESSAGE}_REJECTED`:
        case `${DELETE_NOTIFICATION_MESSAGE}_REJECTED`:
        case `${SEND_NOTIFICATION_EMAILS}_REJECTED`:
            return {
                ...state,
                isSaving: false,
                didInvalidateSave: true,
            };

        case `${CREATE_NOTIFICATION_MESSAGE}_PENDING`:
        case `${UPDATE_NOTIFICATION_MESSAGE}_PENDING`:
        case `${DELETE_NOTIFICATION_MESSAGE}_PENDING`:
        case `${SEND_NOTIFICATION_EMAILS}_PENDING`:
            return {
                ...state,
                isSaving: true,
                didInvalidateSave: false,
            };

        case `${CREATE_NOTIFICATION_MESSAGE}_FULFILLED`:
            return {
                ...state,
                isSaving: false,
                didInvalidateSave: false,
            };

        case `${UPDATE_NOTIFICATION_MESSAGE}_FULFILLED`:
            return {
                ...state,
                isSaving: false,
                didInvalidateSave: false,
            };

        case `${DELETE_NOTIFICATION_MESSAGE}_FULFILLED`:
            return {
                ...state,
                isSaving: false,
                didInvalidateSave: false,
                list: state.list.filter((item) => item.id !== action.payload.id),
            };

        case `${SEND_NOTIFICATION_EMAILS}_FULFILLED`:
            return {
                ...state,
                isSaving: false,
                didInvalidateSave: false,
            };

        default:
            return state;
    }
};

export default notificaciones;
